module.exports = __webpack_public_path__ + "media/images/icons/outlined/node-index-6557456a59b990e8520e6b6370f2bd43.svg";